var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4280EF",
    d: "M24.5 13.294c0-.827-.08-1.68-.213-2.481h-11.55v4.721h6.615a5.57 5.57 0 0 1-2.454 3.708l3.948 3.067c2.32-2.16 3.654-5.308 3.654-9.015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A353",
    d: "M12.737 25.244c3.307 0 6.081-1.094 8.109-2.961l-3.948-3.041c-1.094.747-2.508 1.174-4.161 1.174-3.201 0-5.895-2.161-6.882-5.042L1.8 18.495a12.23 12.23 0 0 0 10.937 6.749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B704",
    d: "M5.855 15.348a7.44 7.44 0 0 1 0-4.695L1.8 7.505a12.26 12.26 0 0 0 0 10.99z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E54335",
    d: "M12.737 5.611a6.68 6.68 0 0 1 4.694 1.841l3.495-3.521c-2.214-2.08-5.148-3.2-8.19-3.174A12.23 12.23 0 0 0 1.8 7.505l4.055 3.148c.987-2.908 3.68-5.042 6.882-5.042"
  })));
};
export default SvgGoogle;